import * as types from "./types";

export const setCustomer = customer => {
  return {
    type: types.SET_CUSTOMER,
    payload: customer,
  };
};

export const setName = name => {
  return {
    type: types.SET_NAME,
    payload: name,
  };
};

export const setTitle = title => {
  return {
    type: types.SET_TITLE,
    payload: title,
  };
};

export const setCellphone = cell_phone => {
  return {
    type: types.SET_CELL_PHONE,
    payload: cell_phone,
  };
};

export const setCountryCode = code => {
  return {
    type: types.SET_COUNTRY_CODE,
    payload: code,
  };
};
